const renderEnhancer = ({ enhancer, canShow = [] }) => {
  const showEnhancer = !canShow.find((showCondition) => !!showCondition === false);

  return enhancer && showEnhancer ? enhancer : null;
};

export default renderEnhancer;
